import { relayStylePagination, getStoreKeyName } from '@apollo/client/utilities';

export default {
  Query: {
    fields: {
      appointment_nodes: relayStylePagination(),
      billing_rules: relayStylePagination(),
      claimable_eligibility_coverages: relayStylePagination([
        'first_name',
        'last_name',
        'date_of_birth',
        'corporate_email',
      ]),
      covered_life_email_verification_history: relayStylePagination(['covered_life_id']),
      covered_life_manual_verification_history: relayStylePagination(['covered_life_id']),
      eligibility_coverages: relayStylePagination(),
      // Every filter arg must be a key arg, otherwise differently filtered requests share one cache
      // entry and Apollo serves the stale rows instead of refetching.
      member_appointments: relayStylePagination([
        'member_id',
        'starting_after',
        'starting_before',
        'kind',
        'status',
        'attended',
      ]),
      // Without `discard_status` the KEPT-only Coverages tab and the profile card share one entry
      // and overwrite each other's edges.
      memberships: relayStylePagination(['member_id', 'discard_status']),
      // Multiple panels query this field with identical arguments but need independent
      // cache entries, so the alias (not just fieldName + args) must be part of the store key.
      covered_life_deactivations: {
        keyArgs: (args, { field, fieldName }) => getStoreKeyName(field?.alias?.value ?? fieldName, args),
      },
    },
  },
};
